class Vector2{
	x:number;
	y:number;

	distanceTo = (other : Vector2) => {
		let sum = Math.pow(this.x - other.x, 2) + Math.pow(this.y - other.y, 2);
		return Math.sqrt(sum);
	}
}

export default function listenForClick(element : HTMLElement, clickCallback : () => void, preventDefault : boolean = true)
{
	let mouseStartPos : Vector2 = new Vector2();
	let mouseEndPos : Vector2 = new Vector2();

	let onMouseDown = (event : MouseEvent) => {
		if (preventDefault){
			if (event.cancelable)
				event.preventDefault();
			event.stopPropagation();
		}
		mouseStartPos.x = event.clientX;
		mouseStartPos.y = event.clientY;
	};

	let onMouseUp = (event : MouseEvent) => {
		if (preventDefault){
			if (event.cancelable)
				event.preventDefault();
			event.stopPropagation();
		}
		mouseEndPos.x = event.clientX;
		mouseEndPos.y = event.clientY;

		if (event.button == 0)
			determineClick();
	};

	let onTouchStart = (event : TouchEvent) => {
		if (preventDefault){
			if (event.cancelable)
				event.preventDefault();
			event.stopPropagation();
		}
		mouseStartPos.x = event.touches[0].clientX;
		mouseStartPos.y = event.touches[0].clientY;
	};

	let onTouchEnd = (event : TouchEvent) => {
		if (preventDefault){
			if (event.cancelable)
				event.preventDefault();
			event.stopPropagation();
		}
		mouseEndPos.x = event.changedTouches[0].clientX;
		mouseEndPos.y = event.changedTouches[0].clientY;

		determineClick();
	};

	let determineClick = () => {
		let distance = mouseStartPos.distanceTo(mouseEndPos);
		if (distance < 5){
			clickCallback();
		}
	};

	let whichPhase = false;
	element.addEventListener('mousedown', onMouseDown, whichPhase);
	element.addEventListener('mouseup', onMouseUp, whichPhase);
	element.addEventListener('touchstart', onTouchStart, whichPhase);
	element.addEventListener('touchend', onTouchEnd, whichPhase);
}